<template>
  <div class="container">
    <div class="news-detail">
      <div class="nd-body">
        <div class="bread-nav">
          <span @click="navgoTo()">全部</span> > 求职技巧 >
          <span class="txt-gray">{{objData.title}}</span>
        </div>
        <div class="nd-body-content">
          <div class="nd-body-view">
            <div class="nd-body-view-title">{{objData.title}}</div>
            <div class="nd-body-view-from">来源:{{objData.froms}} | {{objData.date}} | 求职技巧</div>
            <div class="nd-body-view-content1">
              <img src="../../../static/job-hunting-skills.jpg" alt="map" />
            </div>
            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">1、关于面试时机</h3>
              <div>
                对相当一部分的部门需求者而言，如果求职者不是绝对的让部门需求者满意，那么他们都会有一个想法：在看几个人吧，看后面有没有更合适的；这样不知不觉的最早面试的那一批求职者就被遗忘了，其结果就是做炮灰了，所以面试之前最好先查一查所面试的职位到底什么时候公开放出来的，我个人推荐“启信宝”APP，通过这个APP可以查出来职位首次发布的时间及渠道。
                此外，也有必要查一下该职位的历史发布情况，比如一个公司本来就不大，有些岗位理论上来讲公司只会设一个，比如行政经理，通过查询如果你发现最近一年每隔几个月就发布一次，那就得多留个心眼，要么频繁的换人，要么招一段时间不招了然后过一阵子又接着招。
              </div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">2、关于简历投递渠道（仅以互联网为例）</h3>
              <div>
                个人建议的顺序（按先后顺序排序）：朋友推荐或内部推荐，微信群（很多招聘信息都会留下邮箱），拉勾网及BOSS直聘，猎聘网，智联招聘及前程无忧。
                此外，还可以委托一些热心并且有一定资源的猎头朋友（不管是付费推荐还是友情推荐），但需要说明的是，猎头的本质是帮企业招人或者做双方的撮合匹配，并不是帮人找工作；企业的官方招聘平台也是一个重要的投递渠道；
                此外我上一篇文章分享的那些招聘渠道其实也是求职渠道，可以参考一下。
              </div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">3、关于接听面试电话</h3>
              <div>如果一听就是你耳熟能详的知名平台，当然要约面试了；如果你没听过的平台，尽量不要让HR在电话里面给介绍公司情况和岗位情况，建议说我现在不太方便讲话，麻烦您把公司名称岗位名称及联系方式，发我微信或者邮箱里面，告诉HR微信号就是手机号或者邮箱前缀什么的；收到对方的信息之后，自己从各个渠道去查，看看公司和行业是不是你感兴趣的，职位的薪资怎么样，工作内容有没有挑战性，如果感兴趣就等一会儿回电话过去约面试时间，不感兴趣就自行决定回不回电话了。</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">4、关于面试练手</h3>
              <div>非常非常多的求职者，要么长时间不面试，要么本身就不擅长面试，基本上散失了面试技巧，这个时候我个人建议一定要有面试练手的阶段，简单的讲就是第一批投递的单位，可以投递那些你本来就没有任何意向加入的单位，其目的仅仅只是为了面试练手，面个十个八个让自己的心态和面试技巧差不多能掌握的时候，就可以正经的出去面试了。</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">5、关于没有意向的offer</h3>
              <div>只要薪资在期望的范围之内，我都建议先把offer接下来，如果不想去，那可以等一两天之后回拒offer即可，但强烈不建议拖很久才回复说不去了，多接offer有什么好处呢，第一增加你的自信心，第二可以用来作为你目标单位的谈薪筹码。</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">6、关于积极性和热情</h3>
              <div>对很多级别不太高的岗位而言，单位首先也看重很有经验、专业知识等等，但面试的时候表现得积极热情一些，或者在某些话题上与面试官制造一些共鸣的机会，往往会略微加分。</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">7、关于入职时间</h3>
              <div>除了百分之百满意的offer之外，我都建议把入职时间拖一定的时间，比如明明可以马上入职的，可以说7-10天以后，明明半个月可以入职的，可以说20天左右，但如果单位很着急，那还是别拖了，这么做的好处是什么呢，给自己预留一点时间接着找工作，找到更好的了，就可以有更多的选择，找不到更好的，那就死心塌地的过去干，别外面稍微一有面试机会就按耐不住又想出去面试了。</div>
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">8、关于目前薪资和期望薪资</h3>
              <div>如果目前的待遇本身就一般，那就说工资部分就好了，如果目前福利和奖金还不错，那一定要说全了，否则有可能新单位就按照你工资部分来给你定薪，比如在原薪资部分涨幅多少多少。</div>

              <div>
                再问你期望薪资的时候，一定要先问对方社保公积金基数、一年多少薪、试用期及试用期打几折，然后再看当时的面试发挥水平来回答薪资期望，比如你期望15-20k，你感觉发挥得好，可以要18-20k，赶紧发挥的不好可以要15-18k。
                但如果面试官一上来就问你薪资期望，不建议直接就说，可以借故说对公司的产品，部门架构和工作内容、发展机会还不大了解，薪资虽然是我比较关注的点但不是唯一也不是最重要的点，我更期望您帮我介绍一下情况之后我在说我的薪资期望。
              </div>

              
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">9、关于“你还有什么需要问吗</h3>
              <div>这个时候就不要问任何关于薪资和福利的东西了，务必坚信一点，一旦你的面试通过了，你有的是机会去问这些问题，面试不通过问这些有啥用，建议问一些与你工作有紧密关系的问题，比如产品的竞争力在哪里、部门内组织架构如何、部门有多少团队、大致怎么分工、对我这个岗位有什么期望等等。</div>

              

              
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">10、关于离职原因</h3>
              <div>关于离职原因，这就个性化了，但不论如何，拿过补偿或者被辞退，以及跟领导关系不好等等原因，尽量不要主动说。</div>
                           
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>

            <div class="nd-body-view-content">
              <h3 class="nd-body-view_h3">11、关于新机会最关注的点</h3>
              <div>有的人在意领导，有的人图发展，有的人图头衔，有的人图薪资，有的人图行业转型，但不论如何，对不是太高端的人才而言，我个人都建议：平台在任何时候都是第一位的，一个有知名度的平台往往决定你有没有机会去面试，所以这是至关重要的；其次是职级或者头衔，尽量跳一次槽还是把职级或者头衔提升一下；然后是领导，领导很重要，能决定你的工作内容，发展机会等等，但没有绝对把握的情况下，还是先看平台和职级，因为你找下一份工作的时候，总不能说我跟着某某领导混的吧？至于工作内容应该排在哪里，要看个人目前的主要诉求。</div>
                           
              <!-- <div>{{objData.contenta1}}</div>
              <div>{{objData.contenta2}}</div>-->
            </div>


            <div class="nd-body-view-of">
              <div class="nd-body-view-prev">上一篇：{{objData.prev}}</div>
              <div>下一篇：{{objData.next}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowNewsDetail",
  data() {
    return {
      id: "",
      objData: {
        title: `求职及面试的一些小技巧`,
        date: `2019年9月24日`,
        froms: `播聘`,
        next: `播聘荣登准独角兽百强榜，以技术驱动深耕服务业招聘`,
        prev: `播聘“千人千面”智能推荐策略的产品分析，我的工作我做主 `,
        content: `职场上，有这么一类人，他们每天埋头苦干，加班加点，时不时还在朋友圈晒个周末加班的图片，为的就是让领导看到自己的努力状态，让领导感动，进而给自己升职加薪。`,
        subtitle: `天天加班，努力工作，却在一年后被辞退`,
        contenta: `晓敏在一家新媒体公司负责文案策划工作，天天加班加点，是努力的典型。
早晨第一来到办公室，不仅把办公室打扫的干干净净，还不忘给领导打壶热水；
下午5点半下班，她肯定要等到领导走了以后再走，即使没有任务了，也在办公室坐着“学习”；
如果任务来了，大家都在加班，办公室内5个人，晓敏肯定最后一个走，还不忘发一个半夜加班的朋友圈……
看晓敏的工作状态，大家肯定被她努力的样子感动了，但是，奇怪的是，一年以后她却被公司辞退了。
为什么，她的直属领导说，她虽然努力，我们也看在眼里，非常感动。
但是，她实在是对公司没有任何价值，加班的文案不仅与单位发展不配套，而且有时候还出现这样那样的错字。她在单位已经工作一年了，现在拿出的方案跟去年相比，没有任何进步。
我们之所以留她在这里一年，就是看看她能不能在一年之内，能够有所改变，但是很遗憾，她也只是单纯的很努力而已，没有任何价值。
所以，公司上下一致认为，辞退晓敏是正确的选择，毕竟，我们这里不是慈善机构。
`,
        // contenta1: `4G改变生活，5G改变社会。播聘平台顺应5G的时代趋势而生。作为目前唯一的大数据视频招聘生活社交服务平台，播聘全心致力于“让天下没有难招的工，没有失业的人”的伟大事业。目前国内业务主要集中在全国一线城市及各个省会城市，未来还会扩展至全球数十个重要的地区和国家。`,
        // contenta2: `与传统招聘平台不同的是，播聘结合大数据、云计算、用户画像等技术开创的视频简历与视频面试的生活新方式，是人工智能时代对招工方式的一次颠覆与创新。`,

        subtitleb: `努力工作，会让老板感动吗？`,
        contentb1: `你去烤鸡店买只烤鸡，只会在乎烤鸡好不好吃。你会在乎烤鸡店的老板为了做好这只烤鸡的过程有多艰辛吗？
同样是烤鸡，他却要那么辛苦，你只会觉得他太无能。
你在老板眼中的重要程度不在于你有多努力，你为公司付出了多少汗水，而在于你有多少使用价值，你有多少不可替代性！
不要想着让老板感动，感动是廉价而且被动的。因为努力不是优点，努力只是你的过程，自己默默体会就好了。
高效能的创造出优质的成果才是一个员工的优点。
`,
        // contentb2: `另一方面，企业不仅可以在播聘平台上发布岗位要求和招工信息，还可以上传视频到平台以呈现公司的企业文化、工作环境、工作氛围等，有助于求职者直观、全面地了解企业，吸引志同道合的伙伴，同时增加企业关注度和影响力。`,
        // contentb3: `对求职者来说，播聘平台倡导“秀出真我”，求职者通过视频简历可以直观地展现工作技能、兴趣爱好、个人性格，有效突破文字简历的平面性和局限性，同时提高个人简历的吸引力和价值。`,
        // contentb4: `播聘平台通过系统数据分析求职者的求职意向，精准推送与之匹配的岗位，企业在看过求职者的视频简历后，即可在线视频面试，不仅大幅度降低求职者的时间成本，而且提升了求职成功率。`,

        subtitlec: `老板要用人赚钱，而不是花钱看苦情戏`,
        contentc1: `以前在知乎上看到过这样一个故事：
某公司，办公室四个人。
甲月薪一万，每天上班迟到，下班早退，老板从来不批评他，总是笑脸相迎；
乙月薪一万，上班不是嗑瓜子，补妆，刷娱乐新闻是经常的，偶尔老板交代点事情还很不愿意的推三阻四；
丙月薪一万，老板不打电话让来上班那就几乎看不到人；
丁一本大学毕业，上班总是比所有人早到，打扫卫生、开窗户、整理一天准备干的活，晚上最后一个走无条件加班，总结一天的工作报给老板，关电关水关门，月薪4000。
某日，工商税务的执法人员发现该公司税务上有点问题，遂要求检查，于是老板叫来甲，小甲啊，晚上约你舅舅一起吃个饭呗。
又某日，客户因为质量问题停止了对该公司的货款，老板又叫来乙，小乙啊，下午约你姐夫喝个茶呗，好久没跟他聊天了。
再某日，老板把小丙叫办公室来，小丙啊，听说你大伯调到市政府当秘书长了，来来来，我们是大学同学，他上次说想喝点家乡的茶，这个茶叶你看什么时候帮我捎过去给他一下。
又某日，老板叫来丁，小丁，你这报表怎么做的，几个数据都填错，昨天晚上又忘了关空调吧，让你打电话催一下客户财务的呢？催了没有？货款什么时候到？你这个工作态度，你拿什么让我给你涨工资？唉，你们现在的年轻人，稍微吃点苦就觉得干了很大事情，稍微加点班就要加班费、你这样我很担心你的前途啊……
虽然这个故事有点偏激，但也在一定程度上反应了一个道理“老板要用人赚钱，而不是花钱看苦情戏”
`,

        subtitled: `老板只认“功劳”不认“苦劳”，没有成果的努力，不但不会被感动，反而会被鄙视`,
        contentd1: `你的努力就是“苦劳”，而你创造的价值成果，才是你的“功劳”，一字之差，意义却完全不同。
对老板来说，只会认你的功劳，不会认你的“苦劳”。
柳井正在《经营者成长笔记》中写道：“企业的每个人都是经营者，而一个合格的经营者，就是实现自己承诺，取得成果的人，否则，无效的努力没有任何意义”。
比如，老板让你做一个活动策划案，你在办公室熬了一个通宵，第二天一早就交给领导。
结果领导一看，方案根本没法用，不仅不贴合实际，而且错字连篇。
看着你的熊猫眼，老板也许会说辛苦了，快点休息会。
但老板心里想的一定是：“这个人水平太差了，加班通宵，就弄出来这么个低档次的玩意儿！”
你认为在升职加薪的时候，老板会想到你吗？
因为老板和公司想要的是一份高逼格的活动方案，不是你带来的两个黑眼圈和一脸可怜相。
`,
        // contentd2: `雪莱在《西风颂》中曾说过：如果冬天来了，春天还会远吗？在“经济寒冬”的浪潮下，播聘将搭建起企业和求职者沟通的桥梁，让企业和求职者各取所需、共同发展，为中国的人力资源行业贡献一份力，为中国经济创造新奇迹增添一份彩！`
        subtitlee: `有句话叫屁股决定脑袋，老板考虑问题的层次跟你是不一样的`,
        contentd1: `文明一点的说法，叫做“位置决定想法”。一个人坐什么位置，往往决定了他思考的角度和范围。
作为一名员工，为企业付出那么多，自然希望能够感动老板，得到该有的回报。这个很容易理解。
作为一名老板，我们有自己的情感，自然会被那些为我卖命的员工感动，但是，一到涉及到实际利益的时候，我们就会有很多考虑。
做老板，我当然可以被你感动，只要你不要我为这份感动买单，我可以一天感动好几次，每次都感动出高潮。
但是，你要我为这份感动买单，对不起，我得先想想。
如果你想通过感动我，然后来获取更多的东西，那我也会先衡量你能给我带来多少利益，你为我创造的利益是不是能大于我给你的支出。
因为，升职加薪，牵涉到了企业的支出和收益。直白地告诉大家，老板们想的都是用最小的支出获取最大的利润！能不花钱，就不花钱，能少花钱，就少花钱。

`,
        subtitlef: `没有核心竞争力的感动，都是施舍`,
        contentd1: `不要想着仅凭努力工作，去感动老板。感动了老板又怎样，你自身没有核心价值，核心竞争力，累死也捞不到多少实际好处。纯粹就是浪费自己的业余时间，损耗自己的身体。
努力，真的是件没有门槛的事情。只要想努力，很多人都能做到努力。
让自己拥有核心竞争力，才是最重要的。做好你的本职工作，留点时间给自己去学习、充电、提升吧。让自己拥有职业上的核心价值，这远比努力更能打动人心，更容易带来利益。只有这样子，你才不会成为企业往死里压榨的普通员工。
《资本论》里，有这样一句话：资本来到世间，从头到脚，每个毛孔都滴着血和肮脏的东西。
做生意，就是为了挣钱的，就是为了追求利益最大化的，就是榨取剩余价值的。
做生意，不是做慈善。他们在明面上，谈着奉献，实际上，只是想要员工在现有的薪酬上，付出更多免费的，义务的劳动，获取员工更多的剩余价值。
讲利益的地方，不要讲感情。不要老是做没有意义的加班，否则赔光了健康，赔掉了升值的时间，再无翻盘的机会。
`,
        subtitleg: `提升自己的职场身价，从远离幼稚病开始`,
        contentd1: `过分相信努力，本身就是一种幼稚病。
请不要再相信单一因素判断
这个世界从来不是单因素决定的，你要知道真实世界实在是复杂的多。
就像成为一个好的自媒体人，你不仅要懂内容、你还要懂运营，甚至于商务合作，品牌你都需要涉猎。
不需要你一个人把这些事干完，但是你要懂这些事，才能管理的好下面的人。
①换一个角度思考
当你站在老板的角度，你就知道老板是怎么想的了。
从招聘的角度，理解求职。
你会发现，面试官其实才是真正有压力的，他们担心找不到好的人才，以及看走眼招进来了不合适的人。
从公司高层的角度，理解晋升。
你会发现，他们其实要找的，不过是能力、潜力都强的人才，而你只需要在竞聘的时候证明这一点。
换一个角度思考，事情会容易很多。
②不要排斥与同行社交
当你开始成为团队主管、年龄超过30以后，你会发现很多时候你的精力已经有些跟不上更年轻的新人了。
这个时候，你在团队里发挥的更多是把握方向，排除风险，把控进度的价值。
如果说职场头10年，你需要更多通过作品来证明你的能力。
职场进入第10年以后，你也需要通过行业的认可，来放大你的价值，甚至于获得新的机会。

`
      }
    };
  },
  created(option) {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.id = _this.$route.query.id || ``;
    },
    navgoTo() {
      this.$nav({ path: `/show-news` }, this);
    }
  }
};
</script>

<style scoped="scoped">
@import url("./job-hunting-skills-to.css");
</style>



// WEBPACK FOOTER //
// src/pages/job-hunting-skills-to/job-hunting-skills-to.vue